import { OohPointSchedule, OohPointSpecialSchedule } from '../../graphql/types';

export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const sortSchedules = (schedules: OohPointSchedule[]): OohPointSchedule[] => {
  return [...schedules].sort((a, b) => {
    const dayA = a.dayOfWeek === 7 ? 0 : a.dayOfWeek;
    const dayB = b.dayOfWeek === 7 ? 0 : b.dayOfWeek;
    return dayA - dayB;
  });
};

export const sortSpecialSchedules = (specialSchedules: OohPointSpecialSchedule[]): OohPointSpecialSchedule[] => {
  return [...specialSchedules].sort((a, b) => {
    if (a.month !== b.month) {
      return a.month - b.month;
    }
    return a.dayOfMonth - b.dayOfMonth;
  });
};

export const formatScheduleTime = (
  opening: string | undefined | null,
  closing: string | undefined | null,
): string => {
  if (opening === '00:00' && closing === '23:59') {
    return 'Open 24/7';
  }
  if (!opening || !closing) {
    return 'Closed';
  }
  return `${opening}–${closing}`;
};

export const formatSpecialScheduleDate = (dayOfMonth: number, month: number): string => {
  return `${dayOfMonth} ${MONTH_NAMES[month - 1]}`;
};

export const getDayName = (dayOfWeek: number): string => {
  const dayIndex = dayOfWeek === 7 ? 6 : dayOfWeek - 1;
  return DAY_NAMES[dayIndex];
};